<div class="grid-page absolute mx-sm-4 mt-4">
    <dx-data-grid
        id="gridContainer"
        class="grid theme-dependent"
        noDataText=""
        height="100%"
        [dataSource]="dataSource"
        [allowColumnResizing]="true"
        [focusedRowEnabled]="true"
        [autoNavigateToFocusedRow]="false"
        [showBorders]="true"
        [remoteOperations]="true"
        [columnAutoWidth]="true"
        [wordWrapEnabled]="true"
        [stateStoring]="{ enabled: true, type: 'localStorage', storageKey: 'roles-grid-state', savingTimeout: 0 }"
        [(focusedRowKey)]="roleId"
        (onRowDblClick)="onRowDblClick($event)"
        (onExporting)="onExporting($event)"
        keyExpr="id"
    >
        <dxo-scrolling rowRenderingMode="virtual"></dxo-scrolling>
        <dxo-paging [pageSize]="10"></dxo-paging>
        <dxo-pager
            [visible]="true"
            [displayMode]="'full'"
            [showPageSizeSelector]="true"
            [showInfo]="true"
            [showNavigationButtons]="true"
        >
        </dxo-pager>

        <dxo-load-panel [showPane]="false"></dxo-load-panel>
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-filter-row [visible]="true" [applyFilter]="'auto'"></dxo-filter-row>
        <dxo-column-chooser [enabled]="true"></dxo-column-chooser>
        <dxo-export [enabled]="true" [formats]="['xlsx']"></dxo-export>
        <dxo-toolbar>
            <dxi-item location="before">
                <div class="grid-header">User Roles</div>
            </dxi-item>
            <dxi-item
                location="after"
                locateInMenu="auto"
                widget="dxButton"
                [options]="{ text: 'Filters', icon: 'fa-sharp fa-thin fa-filter', onClick: toggleFilters, stylingMode: 'text' }"
            ></dxi-item>
            <dxi-item location="after" locateInMenu="auto">
                <div class="separator"></div>
            </dxi-item>
            <dxi-item
                location="after"
                locateInMenu="auto"
                widget="dxButton"
                showText="inMenu"
                [options]="{ text: 'Clear Filters', icon: 'fa-sharp fa-thin fa-filter-slash', onClick: clearFilters, stylingMode: 'text' }"
            ></dxi-item>
            <dxi-item
                location="after"
                locateInMenu="auto"
                showText="inMenu"
                widget="dxButton"
                [options]="{
                    text: 'Reset',
                    icon: 'restore',
                    onClick: resetGrid,
                    stylingMode: 'text'
                }"
            ></dxi-item>
            <!-- Separator -->
            <dxi-item location="after" locateInMenu="auto">
                <div class="separator"></div>
            </dxi-item>
            <dxi-item name="exportButton"></dxi-item>
            <dxi-item name="columnChooserButton" locateInMenu="auto"></dxi-item>
            <!-- Separator -->
            <dxi-item location="after" locateInMenu="auto">
                <div class="separator"></div>
            </dxi-item>
            <dxi-item location="after" locateInMenu="never">
                <dx-button
                    class="ms-sm-2"
                    text="New Role"
                    icon="plus"
                    type="default"
                    stylingMode="contained"
                    (onClick)="addRole()"
                ></dx-button>
            </dxi-item>
        </dxo-toolbar>

        <dxi-column
            [dataField]="gridFieldName('name')"
            caption="Name"
            [hidingPriority]="5"
            [minWidth]="150"
        ></dxi-column>
        <dxi-column
            [dataField]="gridFieldName('description')"
            caption="Description"
            [hidingPriority]="4"
            [minWidth]="200"
        ></dxi-column>
        <dxi-column
            [dataField]="gridFieldName('userCount')"
            caption="User Count"
            [hidingPriority]="3"
            [minWidth]="150"
            [dataType]="'number'"
            alignment="left"
        ></dxi-column>
        <dxi-column
            [dataField]="gridFieldName('created')"
            caption="Created"
            [hidingPriority]="3"
            [minWidth]="150"
            [dataType]="'date'"
            [sortOrder]="'desc'"
            [visible]="false"
        ></dxi-column>
        <dxi-column type="buttons">
            <dxi-button text="edit" icon="edit" hint="edit" [onClick]="onEdit"></dxi-button>
            <dxi-button text="delete" icon="trash" hint="delete" [onClick]="onDelete"></dxi-button>
        </dxi-column>
    </dx-data-grid>

    <filter-panel
        [(isOpened)]="isFilterPanelOpened"
        (onSearch)="applyFilters()"
        (onClear)="clearFilters()"
        (pinnedChange)="onPinnedChange()"
    >
        <dx-form [formData]="filterModel">
            <dxi-item
                [dataField]="filterModelName('name')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Name', stylingMode: 'filled' }"
                [colSpan]="1"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('description')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Description', stylingMode: 'filled' }"
                [colSpan]="1"
            ></dxi-item>
        </dx-form>
    </filter-panel>

    <form-popup [(visible)]="isAddRolePopupOpened" (save)="onAddRolePopupSaveClick()" titleText="New Role">
        <add-role-form></add-role-form>
    </form-popup>
</div>
